import React from 'react';
export const HockeyAskAI = () => <div>Hockey Ask AI - Coming Soon</div>;
